import { render } from "./DemographicSection.vue?vue&type=template&id=0c16e0a0&scoped=true"
import script from "./DemographicSection.vue?vue&type=script&lang=js"
export * from "./DemographicSection.vue?vue&type=script&lang=js"

import "./DemographicSection.vue?vue&type=style&index=0&id=0c16e0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c16e0a0"]])

export default __exports__